import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import SideBar from "../../pages/TeacherDasboard/TeachSideBar/SideBar";
import TopBar from "../../pages/TeacherDasboard/TeachSideBar/TopBar";
import Notification from "../../pages/TeacherDasboard/Notificaion/Notification";
import NewNotification from "../../pages/TeacherDasboard/Notificaion/NewNotification";
import UnreadNotification from "../../pages/TeacherDasboard/Notificaion/UnreadNotification";
import Dashboard from "../../pages/TeacherDasboard/Dashboard/Dashboard";
import OnlineTution from "../../pages/TeacherDasboard/OnlineTution/OnlineTution";
import HomeTution from "../../pages/TeacherDasboard/HomeTution/HomeTution";
import MyStudent from "../../pages/TeacherDasboard/MyStudent/MyStudent";
import TeacherMessage from "../../pages/TeacherDasboard/HomeTution/TeacherMessage";
import TeacherChat from "../../pages/TeacherDasboard/HomeTution/TeacherChat";
import TeacherStartClass from "../../pages/TeacherDasboard/HomeTution/TeacherstartClass";
import TeacherProfile from "../../pages/TeacherDasboard/Home/TeacherProfile";
import TeacherPayment from "../../pages/TeacherDasboard/Home/TeacherPayment";
import PaymentDetail from "../../pages/TeacherDasboard/Home/PaymentDetail";
import ProfileSetting from "../../pages/TeacherDasboard/Setting/ProfileSetting";
import SubjectWP from "../../pages/TeacherDasboard/Setting/SubjectWP";
import OtherDetails from "../../pages/TeacherDasboard/Setting/OtherDetails.jsx";
import SecurityPrivacy from "../../pages/TeacherDasboard/Setting/SecurityPrivacy.jsx";
import TeachNotification from "../../pages/TeacherDasboard/Setting/TeachNotification.jsx";
import AddSubject from "../../pages/TeacherDasboard/Setting/AddSubject.jsx";
import SaveDetail from "../../pages/TeacherDasboard/Setting/SaveDetail.jsx";
import Student from "../../pages/TeacherDasboard/Home/Student.jsx";
import Request from "../../pages/TeacherDasboard/Home/Request.jsx";
import ZoomMeetingPage from "../../pages/TeacherDasboard/Meeting/ZoomMeetingPage.jsx";
import StartClass from "../../pages/TeacherDasboard/HomeTution/StartClass.jsx";
import TeacherReport from "../../pages/TeacherDasboard/MyStudent/TeacherReport.jsx";

// `<Navigate to>` takes a literal path, not a route pattern — it can't
// substitute a `:param` placeholder itself, so param-carrying redirects need
// a tiny wrapper that reads the actual matched value and rebuilds the target.
function RedirectWithParam({ to, param }) {
  const params = useParams();
  return <Navigate to={to.replace(`:${param}`, params[param])} replace />;
}

function TeacherLayout() {
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    if (window.innerWidth <= 1024) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    const user = JSON.parse(localStorage.getItem("edo-teacher"));
    if (!user) {
      navigate("/login/mentor-login", { state: { from: pathname } }); // Capture the intended path
    }
  }, [navigate, pathname]);
  return (
    <>
      <TopBar toggleSidebar={toggleSidebar}  totalUnreadCount={totalUnreadCount} />
      <div className="flex">
        <SideBar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="h-screen flex-1 px-2 mt-5">
          <Routes>
            {/* Notification----------------- */}

            <Route path="/notification" element={<Notification />} />
            <Route path="/new-notification" element={<NewNotification />} />
            <Route
              path="/unread-notification"
              element={<UnreadNotification />}
            />

            {/* TEdit Profile */}
            <Route path="/mentor-setting" element={<TeacherProfile />} />
            <Route path="/mentees" element={<Student />} />
            <Route path="/request" element={<Request />} />
            <Route path="/teacher-payment" element={<TeacherPayment />} />
            <Route path="/payment-detail" element={<PaymentDetail />} />
            <Route path="/teacher-report" element={<TeacherReport />} />

            {/* Dashboard--------------------- */}
            <Route path="" element={<Dashboard />} />

            {/* Home--------------------- */}
            <Route path="/home-profile" element={<Dashboard />} />

            {/* Online-Tution----------------------------- */}
            <Route path="/my-sessions" element={<OnlineTution />} />

            {/* Home-Tution---------------- */}
            <Route path="/home-tution" element={<HomeTution />} />
            <Route path="/mentor-message" element={<TeacherMessage />} />
            <Route path="/mentor-chat" element={<TeacherChat setTotalUnreadCount={setTotalUnreadCount} />} />
            <Route path="/teacher-start-class" element={<TeacherStartClass />} />
            <Route path="/start-class/:token" element={<StartClass />} />

            {/* My-Student------------------- */}
            <Route path="/my-mentee" element={<MyStudent />} />
            <Route path="/zoom-meeting-page"element={<ZoomMeetingPage/>} />

            {/* Setting-------------------------- */}

            <Route path="/profile-setting-tech" element={<ProfileSetting />} />
            <Route path="/specialization-tech" element={<AddSubject />} />
            <Route path="/other-detail" element={<OtherDetails />} />
            <Route path="/security" element={<SecurityPrivacy />} />
            <Route path="/teacher-noti-setting" element={<TeachNotification />} />
            <Route path="/add-subject" element={<SubjectWP />} />
            <Route path="/save-detail" element={<SaveDetail />} />

            {/* Kebab-case migration redirects — keep old bookmarks/links working */}
            <Route path="/newNotification" element={<Navigate to="/mentor/new-notification" replace />} />
            <Route path="/unreadNotification" element={<Navigate to="/mentor/unread-notification" replace />} />
            <Route path="/mentorSetting" element={<Navigate to="/mentor/mentor-setting" replace />} />
            <Route path="/teacherPayment" element={<Navigate to="/mentor/teacher-payment" replace />} />
            <Route path="/paymentDetail" element={<Navigate to="/mentor/payment-detail" replace />} />
            <Route path="/teacherReport" element={<Navigate to="/mentor/teacher-report" replace />} />
            <Route path="/homeProfile" element={<Navigate to="/mentor/home-profile" replace />} />
            <Route path="/mysessions" element={<Navigate to="/mentor/my-sessions" replace />} />
            <Route path="/homeTution" element={<Navigate to="/mentor/home-tution" replace />} />
            <Route path="/mentorMessage" element={<Navigate to="/mentor/mentor-message" replace />} />
            <Route path="/mentorChat" element={<Navigate to="/mentor/mentor-chat" replace />} />
            <Route path="/teacherStartClass" element={<Navigate to="/mentor/teacher-start-class" replace />} />
            <Route path="/StartClass/:token" element={<RedirectWithParam to="/mentor/start-class/:token" param="token" />} />
            <Route path="/myMentee" element={<Navigate to="/mentor/my-mentee" replace />} />
            <Route path="/ZoomMeetingPage" element={<Navigate to="/mentor/zoom-meeting-page" replace />} />
            <Route path="/profileSettingTech" element={<Navigate to="/mentor/profile-setting-tech" replace />} />
            <Route path="/specializationTech" element={<Navigate to="/mentor/specialization-tech" replace />} />
            <Route path="/otherDetail" element={<Navigate to="/mentor/other-detail" replace />} />
            <Route path="techerNotiSetting" element={<Navigate to="/mentor/teacher-noti-setting" replace />} />
            <Route path="addSubject" element={<Navigate to="/mentor/add-subject" replace />} />
            <Route path="saveDetail" element={<Navigate to="/mentor/save-detail" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default TeacherLayout;
